<template>
    <v-card class="visitor-log">
        <div class="d-flex-between">
            <div class="content-header">{{ $vuetify.lang.t('$vuetify.visitorActivity.activityLog') }}</div>
            <div class="select-sort">
                <v-select
                    v-model="sortDesc"
                    :items="sortItems"
                    item-text="text"
                    item-value="value"
                    outlined
                    height="40"
                    background-color="#ffffff"
                    @change="getActivityLog()">
                </v-select>
            </div>
        </div>
        <div
            class="activities-log">
            <v-row
                v-for="(activity, activityIndex) in activities"
                :key="activityIndex">
                <v-col
                    class="center"
                    cols="2">
                    <div
                        :class="classVisitor(activity.action)">
                        <i
                            v-if="activity.action === 'Create Visitor'"
                            class="icon-visitor fas fa-user-plus"/>
                        <i
                            v-else-if="activity.action === 'Active Visitor'"
                            class="icon-visitor fas fa-user"/>
                        <i
                            v-else-if="activity.action === 'Inactive Visitor'"
                            class="icon-visitor fas fa-toggle-off"/>
                    </div>
                </v-col>

                <v-col cols="10">
                    <v-row class="activity-label locale-font">
                        {{ activity.date }} {{ activity.action }}
                    </v-row>
                    <v-row class="activity-description">
                        {{ activity.description }}
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </v-card>
</template>

<script>

export default {
    name: 'VisitorActivity',

    computed: {
        sortItems () {
            return [
                {
                    text: this.$vuetify.lang.t('$vuetify.visitorActivity.sortByLasted'),
                    value: true
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.visitorActivity.sortByEarliest'),
                    value: false
                }
            ]
        }
    },
    data () {
        return {
            sortDesc: true,
            activities: []
        }
    },

    methods: {
        async getActivityLog () {
            const visitorId = this.$route.params.id
            let url = `visitor/activity-log/${visitorId}?`
            if (this.sortDesc) {
                url += `&sortDesc=${this.sortDesc}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                const response = res.data.data
                this.activities = response
            }
        },

        classVisitor (action) {
            if (action === 'Active Visitor') {
                return 'active-visitor'
            } else if (action === 'Create Visitor') {
                return 'create-visitor'
            } else if (action === 'Inactive Visitor') {
                return 'inactive-visitor'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__control > .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
}
::v-deep .v-input__append-inner {
    margin-top: 12px;
}
.icon {
    width: 18px;
    height: 21px;
}
.active-visitor {
    background-color: #6c98ba;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05);
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}
.create-visitor {
    background-color: #139888;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05);
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}
.inactive-visitor {
    background-color: #c7c7c7;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05);
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}
.center {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}
.activity-label {
    font-size: 16px;
    color: #131410;
}
.activity-description {
    font-size: 16px;
    color: #6c6c6c;
}
.activities-log {
    height: calc(81vh - 118px);
    overflow-y: scroll;
    overflow-x: hidden;
}

.activities-log::-webkit-scrollbar {
    width: 6px;
    background-color: #FFFFFF;
}

.activities-log::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #e5e5e5;
}

.activities-log::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #FFFFFF;
}
.visitor-log {
    -webkit-box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05) !important;
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05) !important;
    border-radius: 15px !important;
}
.icon-visitor {
    font-size: 20px;
    color: #ffffff;
}
</style>
